module.exports = "images/doc-client-menu.20ae0d366a8473c1864f328d53798fd0.png";